module.exports = __webpack_public_path__ + "img/content3.d3aa0495.png";